import { boronClient } from "../../../api";
import { useBoronMutation } from "../../../hooks/http/useBoronMutation";
import { useKarteTemplatesCacheUpdater } from "../../../hooks/http/useFetchKarteTemplates";
import { KarteTemplateFormInterface } from "../../../interfaces/KarteTemplateInterface";

export const useCreateKarteTemplate = ({
  sectionId,
}: {
  sectionId: string;
}) => {
  const { invalidateKarteTemplates } = useKarteTemplatesCacheUpdater();

  return useBoronMutation(
    async (params: KarteTemplateFormInterface) =>
      await boronClient.POST("/api/v1/sections/{section_id}/karte_templates", {
        params: { path: { section_id: sectionId } },
        body: { karte_template: params },
      }),
    {
      onSuccess: () => {
        invalidateKarteTemplates(sectionId);
      },
    },
  );
};
